import { UnidadeUFC } from "model/ufc/UnidadeUFC";
import { ApiAxios } from "../ApiAxios";


export class ApiUnidadesUFC {
  static readonly REITORIA = 394;

  static async getEstruturaOrganizacional(idReino: number, idUnidade: number): Promise<UnidadeUFC> {
    const response = await ApiAxios.instance.get(`/reinos/${idReino}/ufc/unidades/${idUnidade}/estrutura/organizacional`);
    return response.data;
  }
}
